import { render, staticRenderFns } from "./RetornarCotacaoItemModal.vue?vue&type=template&id=cd549550&scoped=true"
import script from "./RetornarCotacaoItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RetornarCotacaoItemModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RetornarCotacaoItemModal.vue?vue&type=style&index=0&id=cd549550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd549550",
  null
  
)

export default component.exports